import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import commonVi from "./locales/vi/common.json";
import usersVi from "./locales/vi/users.json";
import productsVi from "./locales/vi/products.json";
import customersVi from "./locales/vi/customers.json";
import storesVi from "./locales/vi/stores.json";
import authVi from "./locales/vi/auth.json";
import ordersVi from "./locales/vi/orders.json";
import calendarVi from "./locales/vi/calendar.json";
import landingVi from "./locales/vi/landing.json";
import subscriptionVi from "./locales/vi/subscription.json";

import commonEn from "./locales/en/common.json";
import usersEn from "./locales/en/users.json";
import productsEn from "./locales/en/products.json";
import customersEn from "./locales/en/customers.json";
import storesEn from "./locales/en/stores.json";
import authEn from "./locales/en/auth.json";
import ordersEn from "./locales/en/orders.json";
import calendarEn from "./locales/en/calendar.json";
import landingEn from "./locales/en/landing.json";
import subscriptionEn from "./locales/en/subscription.json";

const resources = {
  vi: {
    common: commonVi,
    users: usersVi,
    products: productsVi,
    customers: customersVi,
    stores: storesVi,
    auth: authVi,
    orders: ordersVi,
    calendar: calendarVi,
    landing: landingVi,
    subscription: subscriptionVi,
  },
  en: {
    common: commonEn,
    users: usersEn,
    products: productsEn,
    customers: customersEn,
    stores: storesEn,
    auth: authEn,
    orders: ordersEn,
    calendar: calendarEn,
    landing: landingEn,
    subscription: subscriptionEn,
  },
};

// Get stored language or set default
const getStoredLanguage = () => {
  const stored = localStorage.getItem("I18N_LANGUAGE");
  if (stored && (stored === 'vi' || stored === 'en')) {
    return stored;
  }
  // Set default to Vietnamese if no valid language is stored
  localStorage.setItem("I18N_LANGUAGE", "vi");
  return "vi";
};

// Initialize i18n synchronously to prevent "not initialized yet" errors
i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getStoredLanguage(),
    fallbackLng: "vi",
    ns: ["common", "users", "products", "customers", "stores", "auth", "orders", "calendar", "landing", "subscription"],
    defaultNS: "common",
    keySeparator: ".",
    nsSeparator: ":",
    interpolation: {
      escapeValue: false,
    },
    debug: false,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'I18N_LANGUAGE',
    },
    react: {
      useSuspense: false, // This prevents "i18n is not initialized yet" errors
    },
  })
  .then(() => {
    console.log('🌐 i18n initialized successfully with language:', i18n.language);
  })
  .catch((error) => {
    console.error('❌ i18n initialization failed:', error);
  });

export default i18n;
